import React from "react";
import Navbar from "../components/Navbar/Navbar";
import PayWithBank from "../components/SideBar/PayWithBank";

const CheckoutWithBank = () => {
  return (
    <>
      <Navbar />
      <PayWithBank />
    </>
  );
};

export default CheckoutWithBank;
